import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '@/utils/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

export const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await authAPI.login(credentials.email, credentials.password);
      localStorage.setItem('authToken', res.data.access_token);
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 admin-panel">
      <div className="w-full max-w-md">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center">
              <Lock size={32} className="text-primary" />
            </div>
          </div>

          <h1 className="text-3xl font-heading font-bold text-center mb-2">Admin Login</h1>
          <p className="text-gray-600 text-center mb-8">KAPISH Corporate Resolution</p>

          <form data-testid="admin-login-form" onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">Email</label>
              <Input
                data-testid="input-email"
                type="email"
                value={credentials.email}
                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                required
                className="w-full"
                placeholder="Enter email"
              />
            </div>

            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">Password</label>
              <Input
                data-testid="input-password"
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                required
                className="w-full"
                placeholder="Enter password"
              />
            </div>

            <Button
              data-testid="login-button"
              type="submit"
              disabled={loading}
              className="w-full bg-secondary text-primary hover:bg-secondary-light py-6 text-base font-semibold"
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>

          <div className="mt-6 text-center text-sm text-gray-500">
            Admin credentials provided via email
          </div>
        </div>
      </div>
    </div>
  );
};
